import React from "react";
import Marquee from "react-fast-marquee";
import { useLang } from "../i18n";
import { Reveal } from "./Motion";

export const Vision = () => {
  const { t } = useLang();
  const v = t.vision;
  return (
    <section id="vision" data-testid="vision-section" className="relative py-20 md:py-48 bg-[var(--bg-secondary)] border-y border-[var(--border)] overflow-hidden">
      {/* background kinetic outline text */}
      <div className="absolute inset-0 flex flex-col justify-center gap-6 opacity-60 pointer-events-none select-none">
        <Marquee speed={40} gradient={false}>
          <span className="font-cormorant italic text-stroke text-7xl md:text-9xl mr-12 whitespace-nowrap">
            {v.title} —
          </span>
        </Marquee>
        <Marquee speed={40} direction="right" gradient={false}>
          <span className="font-cormorant text-stroke text-7xl md:text-9xl mr-12 whitespace-nowrap">
            {t.hero.tagline} —
          </span>
        </Marquee>
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-10">
        <Reveal>
          <div className="max-w-3xl glass border border-[var(--border)] rounded-3xl p-10 md:p-16">
            <span className="overline text-[11px] text-[var(--gold)]">{v.label}</span>
            <h2 className="font-cormorant font-light text-3xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[var(--text-primary)] mt-6">
              {v.title}
            </h2>
            <p className="font-outfit font-light text-base md:text-lg text-[var(--text-secondary)] leading-relaxed mt-8">
              {v.text}
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
